const Header = () => {
  return (
    <a className="todoez-home-link" href="/">
      <h1 className="display-1 text-center py-3">todoEZ</h1>
    </a>
  );
};

export default Header;
